'use client';

import Image from 'next/image';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { BranchScheduleButton } from './buttons/branch-schedule-button.component';
import { SearchSectionTitle } from './titles/search-section-title.component';
import { SearchSectionSubtitle } from './titles/search-section-subtitle.component';
import { SearchSectionBoxButtons } from './common/search-section-box-buttons.component';

import persons from '@/app/(main)/(pages)/_components/search-section/assets/search-section-branch-persons.png';
import { ContentContainer } from '@/components/ui/content-container.component';
import { cn } from '@/utils/cn-tw-merge';
import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

interface SearchSectionBranchProps {
  title: string;
  whatsapp: string | null | undefined;
}

export const SearchSectionBranch = ({ title, whatsapp }: SearchSectionBranchProps) => {
  const branchesLength = 1;
  const analytics = getAnalyticsPlugin();

  function handleClickButton() {
    analytics.track(AnalyticsEnum.CLICK_CITY_BUTTON_SCHEDULE_BRANCH, {
      secao_origem: 'hero',
      nome_secao: 'chamada_principal',
    });
  }

  return (
    <section
      data-testid={DataTestIdEnum.CITY_SEARCH_SECTION_BRANCH}
      className="flex bg-[linear-gradient(129deg,#09462C_36.57%,#0D9259_87.3%)] w-full pt-10 sm:h-auto relative"
    >
      <ContentContainer className="flex flex-col xl:flex-row items-center justify-between xl:gap-10">
        <div className="w-full 3xl:w-1/3 mt-3 xl:mt-0">
          <SearchSectionTitle data-testid={DataTestIdEnum.CITY_SEARCH_SECTION_BRANCH_TITLE}>
            {title}
          </SearchSectionTitle>

          <SearchSectionSubtitle className="mr-0 3xl:mr-0 mb-4" />

          {whatsapp && (
            <BranchScheduleButton
              branchesLength={branchesLength}
              whatsapp={whatsapp}
              variant="default"
              color="success"
              className="hidden xl:flex"
              onClick={handleClickButton}
            />
          )}

        </div>

        <Image
          src={persons}
          alt="Colaboradores"
          draggable={false}
          priority
          className={cn(whatsapp ? 'mb-6 xl:mb-0' : 'mb-0', 'mx-auto xl:mx-0 h-[260px] xl:h-[370px] w-auto object-contain')}
        />

      </ContentContainer>
      {whatsapp && (
        <div className="block xl:hidden absolute bottom-0 left-0 w-full">
          <SearchSectionBoxButtons className="py-6">
            <ContentContainer>
              <BranchScheduleButton
                branchesLength={branchesLength}
                whatsapp={whatsapp}
                variant="default"
                color="success"
                onClick={handleClickButton}
              />
            </ContentContainer>
          </SearchSectionBoxButtons>
        </div>
      )}
    </section>
  );
};
